import React, { useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

export const useShareHandler = () => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const handleShare = useCallback(async (shareData) => {
        let urlToShare = '';

        if (typeof shareData === 'string') {
            urlToShare = shareData;
        } else if (shareData && typeof shareData === 'object' && shareData.id) {
            urlToShare = `${window.location.origin}/media/${shareData.id}`;
        }

        if (!urlToShare) {
            console.error('handleShare called with invalid data:', shareData);
            return;
        }

        if (navigator.share) {
            try {
                await navigator.share({
                    title: 'HereAndNow',
                    text: 'Смотри, что я нашел на карте!',
                    url: urlToShare,
                });
                return;
            } catch (error) {
                if (error.name !== 'AbortError') console.error(error);
            }
        }

        try {
            await navigator.clipboard.writeText(urlToShare);
            setSnackbar({ open: true, message: 'Ссылка скопирована!', severity: 'success' });
        } catch (err) {
            console.error('Could not copy text: ', err);
            setSnackbar({ open: true, message: 'Не удалось скопировать ссылку.', severity: 'error' });
        }
    }, []);

    const ShareSnackbar = (
        <Snackbar
            open={snackbar.open}
            autoHideDuration={4000}
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
            <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                {snackbar.message}
            </Alert>
        </Snackbar>
    );

    return { handleShare, ShareSnackbar };
};